module.exports = __webpack_public_path__ + "static/media/july_2025_5.15d1852a.webp";